import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import EditUser from "../components/user/EditUser";
import { useLoader } from "../context/LoaderContext";
import { IUserDetails } from "../exports/interfaces";
import { useUser } from "../context/UserContext";
import { fetchUsers } from "../api/UserApi";
import { dynamicFailed } from "../hooks/useToast";

const EditUserPage = () => {
  const { setLoading } = useLoader();
  const [users, setUsers] = useState<IUserDetails[]>([]);

  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchUsers()])
      .then(([usersData]) => {
        setUsers(usersData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <EditUser userData={users} />
      </div>
    </PageLayout>
  );
};

export default EditUserPage;
